import React from 'react';
import { useFindEntities } from './useFindEntities';
import { Entities } from '../const';
export var useNonBreakingSpaceEntities = function (readOnly) {
    var NonBreakingSpaceEntity = function () {
        return React.createElement(React.Fragment, null, readOnly ? '\u00a0' : '\u25E6');
    };
    var findNonBreakingSpaceEntities = function (contentBlock, callback, contentState) {
        var findEntities = useFindEntities(Entities.NON_BREAKING_SPACE).findEntities;
        findEntities(contentBlock, callback, contentState);
    };
    return { NonBreakingSpaceEntity: NonBreakingSpaceEntity, findNonBreakingSpaceEntities: findNonBreakingSpaceEntities };
};
